export default __webpack_public_path__ + "695f2a234cfec4f3718a81d33e6e7244.png";